var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpreadsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m14.5.888672 5.5 5.499998-2.75.5-2.75-.5-.5-2.75z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.5 6.38867v-5.499998h-9c-.82875 0-1.5.671248-1.5 1.499998v19.00003c0 .8287.67125 1.5 1.5 1.5h13c.8288 0 1.5-.6713 1.5-1.5v-15.00003z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 9.38867v7.25003h10v-7.25003zm4.375 6.00003h-3.125v-1.75h3.125zm0-3h-3.125v-1.75h3.125zm4.375 3h-3.125v-1.75h3.125zm0-3h-3.125v-1.75h3.125z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpreadsheet);
export default __webpack_public_path__ + "static/media/spreadsheet.b4454b0427bc1f3d0612d774f141199b.svg";
export { ForwardRef as ReactComponent };